<div class="mat-elevation-z8">
    <div class="table-responsive text-center justify-content-center" style="
        font-size: 14px;
        margin-bottom: 20px;
        text-align: center;
        vertical-align: center;">
        <div class="table-header">
            <div class="actions" style="display: flex; justify-content: flex-end; align-items: center">

                <button pButton type="button" style="margin-right: 10px;" icon="pi pi-plus" label="Add Pricing" (click)="openDialog()"></button>
            </div>
        </div>
        <p-table #dt1 dataKey="id" [value]="priorities" [rows]="10" [paginator]="true" [showCurrentPageReport]="true"
            [scrollable]="true"  [loading]="this.loading" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [rowsPerPageOptions]="[10, 25, 50]" [globalFilterFields]="['id', 'transaction_type', 'consultation_name', 'priority_type','is_enabled','renderedAmount','number_of_consultations']">
            <ng-template pTemplate="caption">
                <div class="table-header float-right">
                    <div class="ui-table-globalfilter-container">
                        <input type="text" pInputText size="50" placeholder="Search"
                            (input)="dt1.filterGlobal($event.target.value, 'contains')"
                            style="width: 250px; margin-left: 75%" />
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th style="width:auto;text-align: center;" *ngFor="let col of displayedColumns" [pSortableColumn]="columnFieldMapping[col]">
                        <b>{{ col }}</b>
                        <p-sortIcon [field]="columnFieldMapping[col]"></p-sortIcon>
                    </th>                    
                    <th>
                        <b>Update Status</b>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-priority>
                <tr>
                    <!-- <td>{{ country.is_national_license }}</td> -->
                    <td style="width:auto;text-align: center;">{{ priority.id }}</td>
                    <td style="width:auto;text-align: center;">{{ priority.transaction_type }}</td>
                    <td style="width:auto;text-align: center;">{{ priority.consultation_name }}</td>
                    <td style="width:auto;text-align: center;">{{ priority.priority_type }}</td>
                    <td style="width:auto;text-align: center;">{{ priority.is_enabled }}</td>
                    <td style="width:auto;text-align: center;">{{ priority.renderedAmount }}</td>
                    <td style="width:auto;text-align: center;">{{ priority.number_of_consultations}}</td>
                    <td style="width:auto;text-align: center;">
                        <p-button icon="pi pi-pencil" label="Update" (click)="UpdatePriority(priority.id,priority.is_enabled ? false : true);"></p-button>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <div class="ui-g-12">
        <p style="margin-top: 20px;"><span style="color: red; margin-top: 20px;">Note*:</span> You need to add countries and specialties in order to create pricing.</p>
    </div>
</div>

<p-dialog *ngIf="this.visible" header="Create Pricing" [(visible)]="this.visible" [style]="{ width: '40vw' }"
    (onHide)="Cancel()">
    <form accept-charset="UTF-8" (ngSubmit)="createPriority()" #consultDoctorForm="ngForm">
        <div class="form-unit">
            <label class="form-unit-label"
                style="display: block; margin-bottom: 5px; font-weight: bolder">Country<span style="color: red;">*</span></label>
            <!-- <p-dropdown id="countries" styleClass="input-pill input-dropdown-pill notranslate" [options]="this.createpriority.other_data.countries"
                    [filter]="true" [(ngModel)]="this.createpriority.other_data.selected_country_data"
                    placeholder="Choose Country" [virtualScroll]="true">
                </p-dropdown> -->

            <p-dropdown id="dropdown_country" name="dropdown_country"
                [options]="this.createpriority.other_data.countries"
                [(ngModel)]="this.createpriority.other_data.selected_country_data" #country="ngModel"
                styleClass="input-pill input-dropdown-pill notranslate" [filter]="true" [filterBy]='"label"'
                placeholder="Select country" required>
            </p-dropdown>
        </div>
        <div class="form-unit">
            <label class="form-unit-label"
                style="display: block; margin-bottom: 5px; font-weight: bolder">Specialty</label>
            <p-dropdown styleClass="input-pill input-dropdown-pill notranslate"
                [options]="this.createpriority.other_data.specialties" [filter]="true"
                [(ngModel)]="this.createpriority.other_data.selected_specialty_data" placeholder="Choose Specialty"
                [virtualScroll]="true"></p-dropdown>
        </div>
        <div class="form-unit">
            <label class="form-unit-label" style="display: block; margin-bottom: 5px; font-weight: bolder">Consultation
                type<span style="color: red;">*</span></label>
            <p-dropdown styleClass="input-pill input-dropdown-pill notranslate"
                [options]="this.createpriority.other_data.consultations" [filter]="true"
                [(ngModel)]="this.createpriority.other_data.selected_consultation_type_data"
                placeholder="Choose Consultation type"></p-dropdown>
        </div>
        <div class="form-unit">
            <label class="form-unit-label" style="display: block; margin-bottom: 5px; font-weight: bolder">Is
                enabled<span style="color: red;">*</span></label>
            <p-dropdown styleClass="input-pill input-dropdown-pill notranslate" [options]="status_list" [filter]="true"
                [(ngModel)]="this.createpriority.other_data.selected_is_enabled_data"
                placeholder="Choose Consultation type"></p-dropdown>
        </div>
        <div class="form-unit">
            <label class="form-unit-label" style="display: block; margin-bottom: 5px; font-weight: bolder">Doctor Origin
                Country<span style="color: red;">*</span></label>
            <p-dropdown id="countries" name="countries"
            [options]="this.createpriority.other_data.countries"
            [(ngModel)]="this.createpriority.other_data.selected_doctor_origin_data" #country="ngModel"
            styleClass="input-pill input-dropdown-pill notranslate" [filter]="true" [filterBy]='"label"'
            placeholder="Select doctor origin">
        </p-dropdown>
        </div>

        <div class="form-unit">
            <label class="form-unit-label"
                style="display: block; margin-bottom: 5px; font-weight: bolder">Amount<span style="color: red;">*</span></label>
            <input type="text" pInputText id="amount" name="amount" aria-describedby="key" placeholder="Enter Amount*"
                [(ngModel)]="this.createpriority.api_data.priority.amount" #amount="ngModel" [pKeyFilter]="number_input"
                [class.form-input-error]="amount.invalid && (amount.dirty || amount.touched) && amount.errors.required"
                [class.form-input-success]="!amount.invalid && (amount.dirty || amount.touched) && !amount.errors?.required"
                required />
            <div *ngIf="amount.invalid && (amount.dirty || amount.touched)" class="alert alert-danger">
                <div *ngIf="amount.errors.required" class="alert alert-danger m-2" role="alert">
                    Amount required.
                </div>
                <div *ngIf="amount.errors.FieldValidator" class="alert alert-danger m-2" role="alert">
                    Invalid Amount.
                </div>
            </div>
        </div>

        <div class="ui-g" style="text-align: center">
            <div class="ui-g-12">
                <p-button class="form-unit-member buttonsubmit" type="submit"
                    [disabled]="this.createpriority.api_data.create_api_result.Posting"
                    [style]="{width: '215px', height: '35px','border-radius': '25px'}" label="Submit"></p-button>
            </div>
        </div>
    </form>


    <div class="ui-g-12">
        <app-error-messages [api_result]="this.createpriority.api_data.create_api_result">
        </app-error-messages>
    </div>
</p-dialog>
<p-toast></p-toast>
